import useInterval from 'ui/hooks/use-interval'
import useSeamlyIdleDetachCountdown from 'ui/hooks/use-seamly-idle-detach-countdown'

const SeamlyIdleDetachCounter = () => {
  const { hasCountdown, isActive, remaining, decrementCountdown } =
    useSeamlyIdleDetachCountdown()

  useInterval(
    () => {
      decrementCountdown()
    },
    hasCountdown && isActive && remaining && remaining > 0 ? 1000 : null,
  )
  return null
}

export default SeamlyIdleDetachCounter
